module.exports = __webpack_public_path__ + "img/pcLogo.01863000.png";